module.exports = __webpack_public_path__ + "img/kelly.27eeb668.png";